import { render, staticRenderFns } from "./TeacherNotificationCreate.vue?vue&type=template&id=975bb652"
import script from "./TeacherNotificationCreate.vue?vue&type=script&lang=js"
export * from "./TeacherNotificationCreate.vue?vue&type=script&lang=js"
import style0 from "./TeacherNotificationCreate.vue?vue&type=style&index=0&id=975bb652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports